module.exports = "https://99designs-start-assets.imgix.net/js/8bba0333237e5b7420a93f5911493416.svg";